import { render, staticRenderFns } from "./Ueber.vue?vue&type=template&id=1ac3f56f&"
import script from "./Ueber.vue?vue&type=script&lang=js&"
export * from "./Ueber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports